export const MODAL_CONFIGURATION_AIAGENTS_SECTIONS = (state, action) => {
  const { drawerState } = action.payload;
  return ({
    ...state,
    aiAgents: {
      ...state.aiAgents,
      drawer: {
        ...state.aiAgents.drawer,
        ...drawerState,
      }
    }
  });
};

export const MODAL_CONFIGURATION_AIAGENTS_TOGGLE_DRAWER = (state, action) => {

  return ({
    ...state,
    aiAgents: {
      ...state.aiAgents,
      drawer: {
        ...state.aiAgents.drawer,
        isDone: !state.aiAgents.drawer.isDone,
      }
    }
  });
}

export const OPEN_CONFIGURATION_AIAGENTS_TOGGLE_DRAWER = (state, action) => {
  return ({
    ...state,
    aiAgents: {
      ...state.aiAgents,
      drawer: {
        ...state.aiAgents.drawer,
        isDone: action.payload,
      }
    }
  });
}

